var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportanceFlag01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33268 4.66667H13.0929C13.3911 4.66667 13.5402 4.66667 13.6274 4.72936C13.7035 4.78406 13.7531 4.86826 13.7639 4.96133C13.7764 5.068 13.704 5.19834 13.5592 5.45901L12.6618 7.07432C12.6092 7.16886 12.583 7.21613 12.5727 7.26618C12.5636 7.31049 12.5636 7.35618 12.5727 7.40048C12.583 7.45054 12.6092 7.49781 12.6618 7.59234L13.5592 9.20766C13.704 9.46833 13.7764 9.59867 13.7639 9.70534C13.7531 9.79841 13.7035 9.8826 13.6274 9.93731C13.5402 10 13.3911 10 13.0929 10H8.39935C8.02598 10 7.8393 10 7.69669 9.92734C7.57125 9.86342 7.46926 9.76144 7.40534 9.63599C7.33268 9.49339 7.33268 9.3067 7.33268 8.93333V7.33333M2.66602 14L2.66602 2.66667M2.66602 7.33333H8.26602C8.63938 7.33333 8.82607 7.33333 8.96868 7.26067C9.09412 7.19676 9.1961 7.09477 9.26002 6.96933C9.33268 6.82672 9.33268 6.64004 9.33268 6.26667V3.06667C9.33268 2.6933 9.33268 2.50661 9.26002 2.36401C9.1961 2.23856 9.09412 2.13658 8.96868 2.07266C8.82607 2 8.63938 2 8.26602 2H3.73268C3.35931 2 3.17263 2 3.03002 2.07266C2.90458 2.13658 2.80259 2.23856 2.73868 2.36401C2.66602 2.50661 2.66602 2.6933 2.66602 3.06667V7.33333Z",
    stroke: "#F04438",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportanceFlag01);
export default __webpack_public_path__ + "static/media/Importance-Flag-01.7336f836b65161b6ebf9cc9459cf74be.svg";
export { ForwardRef as ReactComponent };